<app-loader *ngIf="loader"></app-loader>
<div class="banner clientbanner">
    <img src="/assets/images/banner.jpg" alt="Banner">
</div>

<div class="fullwidth bg_purple">
    <div class="container2">
        <!--bof:personalinfo-->
        <div class="personal">
            <!-- <h2>Personal </h2>-->
            <div class="row">
                <div class="pinfo">
                    <div class="infoimg">
                        <img class="img" src="https://api.pinnaklebiz.com/thevoicemall/profile/{{this.profilePic}}"  alt="profile"/>
                    </div>
                </div>
                <div class="pdetails">
                    <h3>{{this.firstName}} {{this.lastName}}</h3>
                    <strong>VM{{this.id}}</strong>
                    <div class="pdetailbx">
                        <div class="row">
                            <span class="addheading">Email</span>
                            <span class="adddetail">{{ currentUser.email }}</span>
                        </div>
                        <div class="row">
                            <span class="addheading">Phone </span>
                            <span class="adddetail">+91 {{ this.contact }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--eof:personalinfo-->
    </div>

    <!--bof:artistrecording-->

    <!--bof: myrecording-->
    <div class="w1200">
        <div class="wedget">
            <!-- bof:wedgetleft -->
            <app-sidebar></app-sidebar>
            <!-- bof:wedgetright -->
            <div class="wedgetright">
                <!--artistrecording-->
                <div class="tab_content">
                    <h3>Artist Recording</h3>
                    <div class="artistrow">
                        <div class="cols"
                            *ngFor="let data of customerBookingDetails | paginate: { itemsPerPage: 12, currentPage: page }">
                            <div class="imgsection"><img src="/assets/images/imgnew.jpg" alt=""></div>
                            <div class="artistdetail">
                                <strong><i class="fa fa-user-circle-o" aria-hidden="true"></i>
                                    VM{{data.artistId}}</strong>
                                <div class="noword">No. Words: <span>₹</span> {{data.totalWord}}</div>
                                <div class="noword">Recording Prices: <span>₹</span> {{data.finalPrice+data.tax}}</div>
                                <div class="btngrp"
                                    *ngIf="data.status == false || data.status == null || data.status == undefined">
                                    <ul>
                                        <li><a class="ongoing">Ongoing</a></li>
                                        <li><a class="view" (click)="viewDetails(data.referenceId)">View</a></li>
                                    </ul>
                                </div>
                                <div class="btngrp" *ngIf="data.status == true">
                                    <ul>
                                        <li><a class="complete">Completed</a></li>
                                        <li><a class="view" (click)="viewDetails(data.referenceId)">View</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <h1 *ngIf="customerBookingDetails?.length == 0">No Data found !</h1>
                    </div>

                    <div class="paginations">
                        <pagination-controls (pageChange)="page = $event"></pagination-controls>
                    </div>
                </div>
                <!--artistrecording-->
            </div>
        </div>
    </div>
</div>
<!--eof: myrecording-->